module.exports = __webpack_public_path__ + "img/logo.294608ab.png";